import HcAccordion from "./HcAccordion/HcAccordion";
import HcCta from "./HcCta/HcCta";
import HcGrid from "./HcGrid/HcGrid";
import HcHeadline from "./HcHeadline/HcHeadline";
import HcHighlight from "./HcHighlight/HcHighlight";
import HcSteps from "./HcSteps/HcSteps";
import HcHero from "./HcHero/HcHero";
import HcUl from "./HcUl/HcUl";
import MegaMenu from "./MegaMenu/MegaMenu";
import Menu2025 from "./Menu2025/Menu2025";
import Nav2025 from "./Nav2025/Nav2025";
import ParallelHighlights from "./ParallelHighlights/ParallelHighlights";
import StructureFilter from "./StructureFilter/StructureFilter";

export default {
  StructureFilter,
  MegaMenu,
  Menu2025,
  Nav2025,
  ParallelHighlights,
  HcHighlight,
  HcSteps,
  HcHero,
  HcAccordion,
  HcUl,
  HcHeadline,
  HcGrid,
  HcCta,
};
